import { FunctionComponent, SVGProps } from 'react';
import { ReactComponent as attractivityIcon } from '@arnold/common/lib/assets/icons/categories/attractivity.svg';
import { ReactComponent as cultureIcon } from '@arnold/common/lib/assets/icons/categories/culture.svg';
import { ReactComponent as customIcon } from '@arnold/common/lib/assets/icons/categories/custom.svg';
import { ReactComponent as fallbackIcon } from '@arnold/common/lib/assets/icons/categories/fallback.svg';
import { ReactComponent as farewellIcon } from '@arnold/common/lib/assets/icons/categories/farewell.svg';
import { ReactComponent as hiringIcon } from '@arnold/common/lib/assets/icons/categories/hiring.svg';
import { ReactComponent as maintenanceIcon } from '@arnold/common/lib/assets/icons/categories/maintenance.svg';
import { ReactComponent as motivationIcon } from '@arnold/common/lib/assets/icons/categories/motivation.svg';
import { ReactComponent as onboardingIcon } from '@arnold/common/lib/assets/icons/categories/onboarding.svg';
import { ReactComponent as organizationIcon } from '@arnold/common/lib/assets/icons/categories/organization.svg';
import { ReactComponent as peopleDevelopmentIcon } from '@arnold/common/lib/assets/icons/categories/peopleDevelopment.svg';
import { ReactComponent as productivityIcon } from '@arnold/common/lib/assets/icons/categories/productivity.svg';
import { ReactComponent as changeIcon } from '@arnold/common/lib/assets/icons/categories/change.svg';
import { ReactComponent as publicIcon } from '@arnold/common/lib/assets/icons/categories/public.svg';
import { ReactComponent as remoteWorkIcon } from '@arnold/common/lib/assets/icons/categories/remoteWork.svg';
import { ReactComponent as pulserIcon } from '@arnold/common/lib/assets/icons/categories/pulser.svg';

import { ProcessStatus, SurveyStatus } from '../../generated/hooks';

/**
 * @param status @todo - there is hidden error,
 * SurveyStatus.ARCHIVED === ProcessStatus.ARCHIVED are true but are different type
 */
export const isSurveyPlanned = (status: SurveyStatus | ProcessStatus): boolean =>
  status === SurveyStatus.Prepared || status === SurveyStatus.Notstarted;

export const isSurveyFinished = (status: SurveyStatus | ProcessStatus): boolean =>
  status === SurveyStatus.Completed || status === SurveyStatus.Archived || status === ProcessStatus.Archived;

export const isSurveyActive = (status: SurveyStatus): boolean =>
  [SurveyStatus.Prepared, SurveyStatus.Ongoing, SurveyStatus.Notstarted, SurveyStatus.Activating].includes(status);

export const getCategoryIcon = (
  custom: boolean,
  categoryCode?: string | null,
  isPublic?: boolean,
): FunctionComponent<SVGProps<SVGSVGElement>> => {
  if (isPublic) {
    return publicIcon;
  }

  if (custom === true) {
    return customIcon;
  }
  switch (categoryCode) {
    case 'attr':
      return attractivityIcon;
    case 'onboard':
      return onboardingIcon;
    case 'remote':
      return remoteWorkIcon;
    case 'devel':
      return peopleDevelopmentIcon;
    case 'motiv':
      return motivationIcon;
    case 'culture':
      return cultureIcon;
    case 'hiring':
      return hiringIcon;
    case 'prod':
      return productivityIcon;
    case 'succ':
      return organizationIcon;
    case 'offboard':
      return farewellIcon;
    case 'reten':
      return maintenanceIcon;
    case 'change':
      return changeIcon;
    case 'pulser':
      return pulserIcon;
    case 'intro':
    default:
      return fallbackIcon;
  }
};
